module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921034151_T.25cd7eb2.jpg";